import { FC, useEffect, useMemo, useRef, useState } from "react";
import { CloseSvg, SearchSvg } from "../svgs/Svgs";
import { AllFilterType } from "./types";

interface Props {
  applyFilter: (filters: AllFilterType) => void;
  allFilters: AllFilterType;
  setAllFilters: (filters: AllFilterType) => void;
  placeholder?: string;
}

const Search: FC<Props> = ({ applyFilter, allFilters, setAllFilters, placeholder }) => {
  const value = useMemo(() => allFilters?.searchFilter || "", [allFilters?.searchFilter]);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [inputActive, setInputActive] = useState(false);

  useEffect(() => {
    const clickedOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setInputActive(false);
      }
    };
    document.addEventListener("mousedown", clickedOutside);
    return () => {
      document.removeEventListener("mousedown", clickedOutside);
    };
  }, []);

  const handleSearchClick = () => {
    if (!inputActive) {
      setInputActive(true);
      requestAnimationFrame(() => {
        inputRef.current?.focus();
      });
    } else {
      handleSearch("");
      setInputActive(false);
    }
  };

  const handleSearch = (nextValue: string) => {
    const all_filters: AllFilterType = { ...allFilters, searchFilter: nextValue };
    if (nextValue === "") {
      delete all_filters.searchFilter;
    }
    setAllFilters(all_filters);
    applyFilter(all_filters);
  };

  return (
    <div
      ref={containerRef}
      className={`custom__search__filter__container${inputActive ? " active" : ""}`}
    >
      <button
        type="button"
        className={`search__icon__container${value !== "" && !inputActive ? " active" : ""}`}
        onClick={handleSearchClick}
        aria-label={inputActive ? "Clear search" : "Open search"}
      >
        {inputActive ? <CloseSvg /> : <SearchSvg />}
      </button>
      <input
        type="text"
        className="custom__search__filter__input"
        placeholder={placeholder || "Search..."}
        value={value}
        onChange={(e) => handleSearch(e.target.value)}
        autoComplete="off"
        ref={inputRef}
      />
      {inputActive && (
        <div className="search__icon__container">
          <SearchSvg />
        </div>
      )}
    </div>
  );
};

export default Search;